<template>
    <div class="develop">
        <h2>开发流程</h2>
        <div class="develop-swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in developInfo" :key="item.id">
                    <img :src="$imgUrl+item.images" alt="">
                    <transition>
                        <div class="descEn">
                            <div class="desc-active">{{item.title}}</div>
                            {{item.account}}
                        </div>
                    </transition>
                </div>
            </div>
	        <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    name: 'Develop',
    props:{
        developInfo: Array
    },
    data () {
        return {
        }
    },
    mounted () {
    },
    methods: {
        imgSwiper () {
            var swiper = new Swiper('.develop-swiper-container', {
                // watchSlidesProgress: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                loop: true,
                loopedSlides: 100,
                effect: "coverflow",
                coverflowEffect: {
                     rotate: 0, //滑动时旋转角度
                     stretch: 0, //聚合宽度
                     depth: 10, //景深
                     modifier: 30, //覆盖叠加层数
                     slideShadows: false //是否阴影
                },
                // autoplay: true,
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                    //clickable :true,
                },
                // on: {
                //     progress: function(progress) {
                //         for (var i = 0; i < this.slides.length; i++) {
                //             var slide = this.slides.eq(i);
                //             var slideProgress = this.slides[i].progress;
                //             var translate = slideProgress * 75 + '%';
                //             var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                //             slide.transform('translateX(' + translate + ')');
                //             slide.css('zIndex', zIndex);
                //             slide.css('opacity', 1);
                //             if (Math.abs(slideProgress) > 3) {
                //                 slide.css('opacity', 0);
                //             }
                //         }
                //     },
                //     setTransition: function(transition) {
                //         for (var i = 0; i < this.slides.length; i++) {
                //             var slide = this.slides.eq(i)
                //             slide.transition(transition);
                //         }
                //     }
                // }
            })
        },
    },
    computed: {
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .develop-swiper-container >>> .swiper-pagination-current
                                    color: #282828
    .develop
        width: 100%
        padding: 8% 0
        text-align: center
        h2
            display:inline-block
            margin: 0 auto
            color: #333
            position: relative
            font-size: 0.4rem
            font-weight: 1000
            margin-bottom: 1.2em
            letter-spacing: 1px
            &:after
                position: absolute
                display: block
                content: ''
                bottom: 0
                right: -0.14rem
                width: 0.34rem
                height: 0.08rem
                background: $yellow
                border-radius: 0.05em
                opacity: 0.8
        .develop-swiper-container
            overflow: hidden
            position: relative
            padding-bottom: 8%
            .swiper-slide
                width: 50%
                padding-bottom: 2.2em
                img
                    width: 100%
                    vertical-align: middle
                .descEn
                    display: none
                    position: absolute
                    bottom: 0
                    width: 100%
                    background: #282828
                    color: #fff
                    line-height: 3em
                    font-size: 0.2rem
                    .desc-active
                        line-height: 6em
                        background: $yellow
                        font-weight: 600
                        color: #282828
                        font-size: 0.26rem
            .swiper-slide-active
                .descEn
                    display: block
            .swiper-pagination
                bottom: 0
                color: #999
            // .v-enter,.v-leave-to
            //     height: 0
            // .v-enter-to,.v-leave
            //     height: 164px    
            // .v-enter-active,.v-leave-active
            //     transition: height .8s
</style>


// WEBPACK FOOTER //
// src/components/mobile/HomeDevelop.vue